module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.9a8fb0d5.svg";